module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/image8_2_main-8bd7b57d048f02bc24b87e6bd8f68f98.png";